/**
 * Builds the initial history from whatever was persisted.
 *
 * `hosted_source` is only honoured when there is no stored history, so an
 * affiliate landing is recorded as the entry point exactly once per visitor.
 */
export const seedHistory = (
  stored: string[],
  hostedSource: string | null,
  asPath: string,
): string[] => {
  const history = [...stored];

  if (!history.length && !!hostedSource?.length) {
    history.push(hostedSource);
  }

  if (asPath !== history[history.length - 1]) {
    history.push(asPath);
  }

  return history;
};
